"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.View = void 0;
const AnswerFieldType_1 = __importDefault(require("@opsbase/lib-data-fieldtype/AnswerFieldType"));
const ViewFieldKey_1 = __importDefault(require("@opsbase/lib-data-viewfield/ViewFieldKey"));
const ViewFieldRegistry_1 = __importDefault(require("@opsbase/lib-data-viewfield/ViewFieldRegistry"));
const DataType_1 = require("@opsbase/lib-datatype/DataType");
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const uuid = __importStar(require("uuid"));
class View {
    constructor(o) {
        var _a;
        if (o === null || o === void 0 ? void 0 : o.lmssType)
            o.type = o === null || o === void 0 ? void 0 : o.lmssType; // BACKWARD COMPAT
        this.apps = (o === null || o === void 0 ? void 0 : o.apps) || [];
        this.id = (o === null || o === void 0 ? void 0 : o.id) || uuid.v4();
        this.title = (o === null || o === void 0 ? void 0 : o.title) || (0, DataType_1.dataTypeLabel)(o === null || o === void 0 ? void 0 : o.type);
        this.isDirty = false;
        this.isSystem = true;
        this.isOwned = false;
        this.isShared = false;
        this.autoRefresh = (o === null || o === void 0 ? void 0 : o.autoRefresh) || 0;
        this.hideEmptyGroups = (o === null || o === void 0 ? void 0 : o.hideEmptyGroups) || false;
        this.chartBox = (o === null || o === void 0 ? void 0 : o.chartBox) || { visible: false, charts: [] };
        this.type = o === null || o === void 0 ? void 0 : o.type;
        this.sortBy = (o === null || o === void 0 ? void 0 : o.sortBy) && (o === null || o === void 0 ? void 0 : o.fields) ? o.fields.find(f => f.key === o.sortBy) : undefined;
        this.sortByDesc = (o === null || o === void 0 ? void 0 : o.sortByDesc) || false;
        this.pinField =
            (o === null || o === void 0 ? void 0 : o.pinField) && (o === null || o === void 0 ? void 0 : o.fields) ? o.fields.find(f => f.key === o.pinField) : undefined;
        this.filters = ((o === null || o === void 0 ? void 0 : o.filters) || []).map(filter => {
            if (filter.to)
                filter.to = (0, moment_timezone_1.default)(filter.to);
            if (filter.from)
                filter.from = (0, moment_timezone_1.default)(filter.from);
            return filter;
        });
        this.groupBys = ((o === null || o === void 0 ? void 0 : o.groupBys) || []).map(groupBy => ({
            offset: 0,
            limit: 30,
            queryFieldKey: typeof groupBy === 'string' ? groupBy : groupBy['queryFieldKey'],
            timeInterval: typeof groupBy === 'string' ? undefined : groupBy['timeInterval'],
        }));
        this.highlightedGroups = (o === null || o === void 0 ? void 0 : o.highlightedGroups) || [];
        this.highlightedDateRange = (o === null || o === void 0 ? void 0 : o.highlightedDateRange) || undefined;
        this.fields = ((o === null || o === void 0 ? void 0 : o.fields) || []).map(f => {
            if (f.key === ViewFieldKey_1.default.QUESTIONANSWER) {
                return Object.assign(Object.assign({}, f), { fieldType: f.fieldType || AnswerFieldType_1.default.ANSWER_CHECK, gqlFields: 'form, isScoreEnabled' });
            }
            return Object.assign(Object.assign({}, ViewFieldRegistry_1.default[f.key]), f);
        });
        this.reportPage = (_a = o === null || o === void 0 ? void 0 : o.reportPage) !== null && _a !== void 0 ? _a : 0;
        this.fieldsChanged = new Date();
        this.filtersChanged = new Date();
        this.groupsChanged = new Date();
        this.sortingChanged = new Date();
        this.pinningChanged = new Date();
        this.maxVisibleFields = (o === null || o === void 0 ? void 0 : o.maxVisibleFields) || 50000;
    }
    get query() {
        return {
            type: this.type,
            sortBy: this.sortBy,
            sortByDesc: this.sortByDesc,
            fields: this.fields,
            groupBys: this.groupBys,
            filters: this.filters,
            pinField: this.pinField,
        };
    }
}
exports.View = View;
exports.default = View;
